// T-531 — Un deal n'est proposé par le devis installateur (OMV) que s'il est B2B
// (`type` ou `regime` = "b2b"), rattaché à un délégataire actif du tenant et doté
// d'un taux > 0. Source unique de cette règle : l'onglet Aides (liste des deals,
// liste des délégataires) et l'assistant de devis la lisent ici.

export const estDealB2B = (deal) => ((deal?.type || deal?.regime) === "b2b");

// Raisons pour lesquelles un deal n'apparaît pas (ou ne sert à rien) dans le devis.
// Liste vide = deal utilisable.
export function raisonsDealInutilisable(deal, delegataires = []) {
  const raisons = [];
  if (!deal) return ["deal absent"];
  if (deal.actif === false) raisons.push("deal inactif");
  if (!estDealB2B(deal)) raisons.push("deal non B2B : non proposé dans les devis");
  const deleg = (delegataires || []).find(d => (d.id || "") === (deal.delegataire_id || ""));
  if (!deal.delegataire_id || !deleg) raisons.push("sans délégataire actif");
  if (!(Number(deal.prix_unitaire) > 0)) raisons.push("taux à 0");
  return raisons;
}

// Pourquoi un délégataire n'est proposé par AUCUN deal du devis. Vide = proposé.
export function raisonDelegataireAbsentDesDevis(delegataire, deals = [], delegataires = []) {
  const siens = (deals || []).filter(d => (d.delegataire_id || "") === (delegataire?.id || ""));
  if (siens.some(d => raisonsDealInutilisable(d, delegataires).length === 0)) return "";
  if (siens.length === 0) return "aucun deal B2B : créez-le par « Nouveau deal B2B »";
  if (!siens.some(estDealB2B)) return "son deal n'est pas B2B : créez-le par « Nouveau deal B2B »";
  return "son deal B2B n'a pas de taux : renseignez le taux du contrat";
}

// Erreurs du formulaire « Nouveau deal B2B » — l'enregistrement est bloqué tant qu'il y en a.
export function erreursFormulaireDealB2B(form, delegataires = []) {
  const e = [];
  if (!String(form?.nom || "").trim()) e.push("le nom du deal");
  if (!form?.delegataire_id || !(delegataires || []).some(d => (d.id || "") === form.delegataire_id)) e.push("le délégataire");
  if (!(Number(String(form?.prix_unitaire ?? "").replace(",", ".")) > 0)) e.push("le taux du contrat (supérieur à 0)");
  if (!phraseRenseignee(form)) e.push("la phrase prime (devis)");
  return e;
}

// T-538 — La phrase prime est imprimée par le devis sous la prime (T-534). Un deal B2B
// sans phrase donne un devis sans la mention CEE : la création la pré-remplit, l'écran
// signale un deal existant qui n'en a pas, et l'enregistrement est refusé sans elle.
// Phrase standard = formule des deals B2B OMV existants (texte exact relevé dans la copie PROD
// du 29/10). Pas « la phrase du deal le plus récent » : certains deals portent une phrase propre
// à leur délégataire (ex. « Remise… représenté par EBS Energie »), qui ne vaut pas pour un autre.
export const PHRASE_DEAL_B2B_STANDARD =
  "La présente offre comprend une prime d'un montant de {montant}, qui vous est offerte par {delegataire}({siren}) " +
  "dans le cadre de son rôle actif et incitatif, au titre du dispositif des certificats d'économies d'énergie.";

export const phraseRenseignee = (deal) => String(deal?.phrase || "").trim().length > 0;
